import { useState } from 'react';

import { ToggleButton } from '../components/UI';

export const useToggle = ({ description }: { description: string }) => {
  const [toggleState, setToggleState] = useState(false);

  const handleToggleState = (newState?: boolean) =>
    setToggleState((pr) => newState ?? !pr);

  const ToggleComponent = ({ className = '' }: { className?: string }) => (
    <div
      className={`
        ${className}
        flex
        items-center
        gap-2
      `}
    >
      <ToggleButton
        renderLabelOn={'left'}
        activatedLabel={description}
        deactivatedLabel={description}
        isActivated={toggleState}
        onActivate={handleToggleState}
        onDeactivate={handleToggleState}
      />
    </div>
  );
  return { ToggleComponent, toggleState, handleToggleState };
};
